import { useUserPermissions } from "@/hooks/useUserPermissions";

/**
 * Viewing the org structure is open to platform admins (the list endpoint needs no users:*
 * permission). Creating and editing departments is the users module's, so it follows users:update.
 */
export function useDepartmentPermissions() {
  const { canEdit, isSuperAdmin, isSubAdmin } = useUserPermissions();

  return {
    canView: isSuperAdmin || isSubAdmin,
    canManage: canEdit,
  };
}
